import { render, staticRenderFns } from "./GlobalLinks.vue?vue&type=template&id=8275098e&scoped=true&"
import script from "./GlobalLinks.vue?vue&type=script&lang=js&"
export * from "./GlobalLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8275098e",
  null
  
)

export default component.exports